import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Verify Your Email", -1)
const _hoisted_2 = { class: "button-group" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Verify email ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Get a new code ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Verification code sent! ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Please check your email. Your verification code will expire in 10 minutes. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
    }, [
      _hoisted_1,
      _createVNode(_component_base_input, {
        class: "full-width",
        placeholder: "Verification code",
        error: _ctx.verificationCodeError,
        modelValue: _ctx.verificationCode,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.verificationCode) = $event)),
        modelModifiers: { trim: true }
      }, null, 8, ["error", "modelValue"]),
      _createVNode(_component_base_input, {
        class: "full-width",
        placeholder: "Password",
        type: "password",
        modelValue: _ctx.password,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
        modelModifiers: { trim: true }
      }, null, 8, ["modelValue"]),
      _createVNode(_component_base_input, {
        class: "full-width",
        placeholder: "Password again",
        type: "password",
        error: _ctx.passwordError,
        modelValue: _ctx.passwordAgain,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.passwordAgain) = $event)),
        modelModifiers: { trim: true }
      }, null, 8, ["error", "modelValue"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_loading_button, {
          "button-type": "button--inverted",
          loading: _ctx.loading
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_loading_button, {
          "button-type": "button--no-bg",
          type: "button",
          loading: _ctx.resendEmailLoading,
          "show-arrow": false,
          onClick: _ctx.resendEmail
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ])
    ], 32),
    _withDirectives(_createVNode(_component_modal, {
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showModal = false))
    }, {
      title: _withCtx(() => [
        _hoisted_5
      ]),
      message: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.showModal]
    ])
  ]))
}